module.exports = __webpack_public_path__ + "img/subscription.793128f8.svg";